/** @format */

import { Backdrop, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { refreshKeyConfig } from 'src/config';
import { selectRefreshByKey } from 'src/store/app-slice';
import { checkExpired } from 'src/utils/check';

export const PageLoading = ({ open = false }) => {
  const refreshIndex = useSelector((state) => selectRefreshByKey(state, refreshKeyConfig.pageLoading));

  const [openState, setOpenState] = useState(false);
  const handleClose = () => {
    setOpenState(false);
  };
  const handleOpen = () => {
    setOpenState(true);
  };

  useEffect(() => {
    if (refreshIndex && !checkExpired(refreshIndex, 2)) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [refreshIndex]);
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: 999999, opacity: 'unset', m: '0px!important' }}
      open={openState || open}
      //   onClick={handleClose}
    >
      <CircularProgress disableShrink />
    </Backdrop>
  );
};
